<template>
    <div class="c-case-home">
        <LayoutContent>
            <div class="c-content-title-box">
                <p class="title-text">
                    {{ $t("main:应用场景及项目") }}<span class="text-import">{{ $t("main:案例") }}</span>
                </p>
            </div>
            <div class="c-case-tabs">
                <div class="c-tabs-header-box">
                    <div class="tabs-header-item is-active">
                        <span class="item-icon">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#gvfont-case-icon"></use>
                            </svg>
                        </span>
                        <span class="item-text">{{ $t("main:游戏语音") }}</span>
                    </div>
                    <!-- <div class="tabs-header-item">
                        <span class="item-icon">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#gvfont-case-icon"></use>
                            </svg>
                        </span>
                        <span class="item-text">{{ $t("main:社交IM") }}</span>
                    </div> -->
                </div>
                <div class="c-tabs-content-box">
                    <div class="cd-tabs-content-inner">
                        <div class="inner-content">
                            <div class="cd-inner-item">
                                <p class="inner-title">{{ $t("main:应用介绍") }}</p>
                                <p class="inner-detail">
                                    游戏语音GVoice围绕多种游戏场景打造了实时语音、语音消息、语音识别、范围语音、3D语音、文明语音、魔音、未成年声纹识别系统等行业领先的产品能力，现已成熟应用于《王者荣耀》、《和平精英》、《英雄联盟》、《PUBG
                                    - MOBILE》、《Call of Duty: Mobile》等全球上千款产品。
                                </p>
                            </div>
                            <div class="cd-inner-item">
                                <p class="inner-title">{{ $t("main:接入项目") }}</p>
                                <div class="c-inner-projects-box">
                                    <ul class="cd-inner-projects-list">
                                        <li class="projects-list">
                                            <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-01.png" />
                                        </li>
                                        <li class="projects-list">
                                            <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-02.png" />
                                        </li>
                                        <li class="projects-list">
                                            <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-03.png" />
                                        </li>
                                        <li class="projects-list">
                                            <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-04.png" />
                                        </li>
                                        <li class="projects-list">
                                            <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-05.png" />
                                        </li>
                                    </ul>
                                    <span class="cd-projects-button">
                                        <a href="/case"><i class="gvfont gvfont-arrow-right"></i></a>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="inner-side">
                            <div class="inner-img">
                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/home/case-home-img.png" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LayoutContent>
    </div>
</template>

<script>
import LayoutContent from "@/components/UI/LayoutContent.vue";
export default {
    name: "CaseHome",
    components: { LayoutContent },
};
</script>

<style scoped lang="less">
@import "/web/src/assets/css/theme.less";
.c-case-home {
    background: #fff url(https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/home/case-home-bg.png) no-repeat center center;
}
.c-tabs-header-box {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #b4b6b7;
    .tabs-header-item {
        display: flex;
        align-items: flex-end;
        justify-content: center;
        padding: 16px 56px;
        cursor: default;
        &:hover {
            .item-text {
                color: @primary-color;
            }
        }
        &.is-active {
            position: relative;
            &:after {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                bottom: -1px;
                height: 2px;
                background: @primary-color;
            }
            .item-text {
                color: @primary-color;
            }
        }
        & + .tabs-header-item {
            margin-left: 48px;
        }
        .item-icon {
            & + .item-text {
                margin-left: 8px;
            }
            .icon {
                width: 26px;
                height: 25px;
            }
        }
        .item-text {
            font-size: 26px;
            color: #666666;
        }
    }
}
.c-tabs-content-box {
    padding: 64px 0;
}
.cd-tabs-content-inner {
    display: flex;
    align-items: center;
    .inner-content {
        flex: 1;
        margin-top: 16px;
        & + .inner-side {
            margin-left: 80px;
        }
        .inner-side {
            .inner-img {
                img {
                    width: 580px;
                }
            }
        }
    }
}
.cd-inner-item {
    & + .cd-inner-item {
        margin-top: 48px;
    }
    .inner-title {
        font-size: 20px;
        color: #222;
        font-weight: bold;
        & + .inner-detail {
            margin-top: 16px;
        }
        & + .c-inner-projects-box {
            margin-top: 24px;
        }
    }
    .inner-detail {
        font-size: 16px;
        color: #666666;
        line-height: 26px;
    }
}

.cd-inner-projects-list {
    display: flex;
    align-items: center;
    .projects-list {
        & + .projects-list {
            margin-left: 38px;
        }
        img {
            width: 60px;
            height: 60px;
        }
    }
}
.cd-projects-button {
    cursor: pointer;
    &:hover {
        .gvfont {
            color: @primary-color;
        }
    }
    .gvfont {
        font-size: 32px;
        color: #666666;
    }
}

.c-inner-projects-box {
    display: flex;
    align-items: center;
    .cd-inner-projects-list {
        & + .cd-projects-button {
            margin-left: 32px;
        }
    }
}
.c-content-title-box {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 80px 0 48px;
    .title-text {
        font-size: @title-font-size;
        color: #222;
        .text-import {
            color: @primary-color;
        }
    }
}
@media only screen and (max-width: 1200px) {
    .c-case-home {
        padding-left: 24px;
        padding-right: 24px;
    }
    .c-content-title-box {
        padding: 32px 0 8px;
        .title-text {
            font-size: 32px;
        }
    }
    .c-tabs-header-box {
        .tabs-header-item {
            padding: 8px 48px;
            .item-text {
                font-size: 20px;
            }
            .item-icon {
                .icon {
                    width: 24px;
                    height: 22px;
                }
            }
        }
    }
    .c-tabs-content-box {
        padding: 32px 0;
    }
    .cd-inner-item {
        & + .cd-inner-item {
            margin-top: 24px;
        }
        .inner-title {
            font-size: 16px;
        }
        .inner-detail {
            font-size: 14px;
        }
    }
    .cd-inner-projects-list {
        .projects-list {
            & + .projects-list {
                margin-left: 24px;
            }
            img {
                width: 48px;
                height: 48px;
            }
        }
    }
    .cd-projects-button {
        .gvfont {
            font-size: 24px;
        }
    }
    .cd-tabs-content-inner {
        .inner-content {
            margin-top: 24px;
            & + .inner-side {
                margin-left: 24px;
            }
        }
        .inner-side {
            .inner-img {
                img {
                    max-width: 480px;
                }
            }
        }
    }
}
@media only screen and (max-width: 995px) {
    .c-content-title-box {
        padding: 24px 0 4px;
        .title-text {
            font-size: 24px;
        }
    }
    .c-tabs-header-box {
        .tabs-header-item {
            padding: 8px 48px;
            .item-text {
                font-size: 16px;
            }
            .item-icon {
                .icon {
                    width: 20px;
                    height: 18px;
                }
            }
        }
    }
    .c-tabs-content-box {
        padding: 24px 0;
    }
    .cd-inner-item {
        .inner-title {
            font-size: 16px;
            & + .inner-detail {
                margin-top: 8px;
            }
            & + .c-inner-projects-box {
                margin-top: 16px;
            }
        }
        .inner-detail {
            font-size: 14px;
            line-height: 1.6;
        }
    }
    .cd-inner-projects-list {
        .projects-list {
            & + .projects-list {
                margin-left: 24px;
            }
            img {
                width: 48px;
                height: 48px;
            }
        }
    }
    .cd-projects-button {
        .gvfont {
            font-size: 24px;
        }
    }
    .cd-tabs-content-inner {
        flex-direction: column-reverse;
        .inner-content {
            & + .inner-side {
                margin-left: 0;
            }
        }
        .inner-side {
            width: 100%;
            .inner-img {
                display: flex;
                justify-content: center;
                width: 100%;
                img {
                    width: 100%;
                    max-width: 480px;
                }
            }
        }
    }
}
@media only screen and (max-width: 576px) {
    .c-tabs-header-box {
        .tabs-header-item {
            padding: 8px;
        }
    }
    .cd-inner-projects-list {
        & + .cd-projects-button {
            margin-left: 24px;
        }
        .projects-list {
            & + .projects-list {
                margin-left: 16px;
            }
            img {
                width: 40px;
                height: 40px;
            }
        }
    }
}
</style>
